var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpnavbarprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19H0V17.1905C0 15.9907 0.460936 14.84 1.28141 13.9917C2.10188 13.1433 3.21468 12.6667 4.375 12.6667H9.625C10.7853 12.6667 11.8981 13.1433 12.7186 13.9917C13.5391 14.84 14 15.9907 14 17.1905V19ZM7 10.8571C6.31056 10.8571 5.62787 10.7167 4.99091 10.4439C4.35395 10.1711 3.7752 9.77124 3.28769 9.26715C2.80018 8.76306 2.41347 8.16462 2.14963 7.506C1.8858 6.84737 1.75 6.14146 1.75 5.42857C1.75 4.71568 1.8858 4.00977 2.14963 3.35115C2.41347 2.69252 2.80018 2.09408 3.28769 1.58999C3.7752 1.0859 4.35395 0.686037 4.99091 0.413225C5.62787 0.140414 6.31056 -1.06229e-08 7 0C8.39239 2.14539e-08 9.72775 0.571937 10.7123 1.58999C11.6969 2.60805 12.25 3.98882 12.25 5.42857C12.25 6.86832 11.6969 8.2491 10.7123 9.26715C9.72775 10.2852 8.39239 10.8571 7 10.8571Z",
    fill: "#9D1CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpnavbarprofile);
export default __webpack_public_path__ + "static/media/tpnavbarprofile.6e8a598e4d41cbb9e440308f1512c419.svg";
export { ForwardRef as ReactComponent };